<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="bulk-action float-right" *ngIf="(vm$ | async) as vm">
    <button *ngIf="allowPagination" class="pagination-button pagination-first"
            aria-label="Navigate to first page"
            (click)="first()">
        <scrm-image class="sicon-2x pagination-icons" image="paginate_first">
        </scrm-image>
    </button>
    <button *ngIf="allowPagination" class="pagination-button pagination-previous"
            aria-label="Previous page"
            (click)="previous()">
        <scrm-image class="sicon-2x pagination-icons" image="paginate_previous">
        </scrm-image>
    </button>
    <span class="pagination-count"
          [ngClass]="{
            'hide-pagination-count': displayResponsiveTable, 'centre-pagination': !allowPagination
          }"
    >
      ({{vm.pageCount.pageFirst}}
        - {{vm.pageCount.pageLast}} {{vm.appStrings['LBL_LIST_OF'] || ''}} {{vm.pageCount.total}})
    </span>
    <button *ngIf="allowPagination" class="pagination-button pagination-next"
            aria-label="Next page"
            (click)="next()">
        <scrm-image class="sicon-2x pagination-icons" image="paginate_next">
        </scrm-image>
    </button>
    <button *ngIf="allowPagination" class="pagination-button pagination-last"
            aria-label="Navigate to last page"
            (click)="last()">
        <scrm-image class="sicon-2x pagination-icons" image="paginate_last">
        </scrm-image>
    </button>
</div>
